var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page noselect pageAsOverlay" },
    [
      _vm.$store.getters.showDialogContainer
        ? _c("AppHead", {
            on: {
              menu: function ($event) {
                return _vm.$ebus.$emit("goBack")
              },
            },
          })
        : _vm._e(),
      _c("v-container", { attrs: { "grid-list-md": "" } }, [
        _c(
          "div",
          { staticClass: "text-left mt-7" },
          [
            _c("h2", [_vm._v("Allgemeine Geschäftsbedingungen")]),
            _c("div", { staticClass: "spacer-15" }),
            _c("CmsBlock", { attrs: { blockName: "AGB" } }),
          ],
          1
        ),
      ]),
      _vm.$store.getters.showDialogContainer
        ? _c(
            "div",
            { staticClass: "fixed-continue" },
            [
              _c("v-container", [
                _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "btn-df",
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.$ebus.$emit("goBack")
                          },
                        },
                      },
                      [_vm._v(" Zurück zur Bestellung ")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }